import { DocumentSignKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetDocumentSignMergeStatusRequest, GetDocumentSignMergeStatusResponse } from "@maven-rest/docs/DocumentMerge.dto";
import { DocumentSignMergeUrl } from "@maven-rest/docs/DocumentSignMerge.url";

export function useMergedDocumentDownloadStatusQuery(
  req: GetDocumentSignMergeStatusRequest,
  options?: SimpleQueryOptions<GetDocumentSignMergeStatusResponse, GetDocumentSignMergeStatusRequest>
) {
  return useBaseQuery({
    queryKey: [DocumentSignKey.DocumentSignMergeStatus, String(req.fileExportHistoryId)],
    fnOption: {
      url: DocumentSignMergeUrl.getDocumentSignMergeStatus(req.fileExportHistoryId),
      request: req,
    },
    ...options,
  });
}
